import React, { useEffect, useRef, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import type { TypographyProps } from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import type { LinkProps } from '@material-ui/core/Link'
import clsx from 'clsx'

import { useTruncateStyles } from './truncate.styles'
import { useDisclosure } from '../../utils'

type TruncateProps = TypographyProps & {
  lines?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  LinkProps?: LinkProps
  translate?: {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    [key: string]: any
  }
}

export const Truncate: React.FC<TruncateProps> = (props) => {
  const classes = useTruncateStyles()
  const [isTruncated, setIsTruncated] = useState(false)
  const { isOpen, onOpen } = useDisclosure()
  const theme = useTheme()
  const ref = useRef<HTMLSpanElement | null>(null)
  const { lines = 3, LinkProps, ...typographyProps } = props

  const themeTypographyProps =
    typographyProps.variant !== 'inherit' &&
    typographyProps.variant !== 'srOnly'
      ? theme.typography[typographyProps?.variant ?? 'body1']
      : {}

  const lineHeight =
    typeof themeTypographyProps.lineHeight === 'string'
      ? parseFloat(themeTypographyProps.lineHeight)
      : themeTypographyProps.lineHeight

  useEffect(() => {
    const heightElement = parseFloat(
      theme.typography.pxToRem(ref.current?.getBoundingClientRect().height ?? 0)
    )

    if (lineHeight && heightElement && heightElement > lineHeight * lines) {
      setIsTruncated(true)
    }
  }, [lines, lineHeight, theme.typography])

  return (
    <>
      <Typography
        {...typographyProps}
        ref={ref}
        className={clsx(
          classes.root,
          {
            [classes[`line-${lines}` as const]]: isTruncated && !isOpen
          },
          typographyProps.className
        )}
      >
        {props.children}
      </Typography>
      {isTruncated && !isOpen && (
        <Link
          color="textSecondary"
          variant="subtitle2"
          onClick={onOpen}
          className={classes.showMore}
          {...LinkProps}
        >
          {props.translate['show-more']}
        </Link>
      )}
    </>
  )
}
